import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { view, i18next } from '@yola/ws-sdk';
import store from 'src/js/store';
import canBeMovedBackward from '../helpers/can-be-moved-backward';
import useElementSiblingWatcher from '../hooks/use-element-sibling-watcher';
import Trigger from '../../../../common/components/trigger';
import trackReorderCompositeWidgetClicked from '../trackers/track-reorder-composite-widget-clicked';
import constants from '../constants/common';

const { Icon } = designSystem;

const MoveBackward = ({ elementId }) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const disabled = useElementSiblingWatcher(
    liveElement,
    (element) => element.previousElementSibling !== null,
    (element) => !canBeMovedBackward(element)
  );

  const moveOnBackground = useCallback(() => {
    const { previousElementSibling } = liveElement;

    if (previousElementSibling) {
      const refElementId = view.accessors.getLiveElementId(previousElementSibling);
      store.dispatch(view.actions.shiftElement(elementId, refElementId, 'beforebegin'));

      trackReorderCompositeWidgetClicked({
        triggerId: constants.MOVE_BACKWARD,
        elementId,
      });
    }
  }, [elementId, liveElement]);

  return (
    <Trigger data-tip={i18next.t('Move backward')} disabled={disabled} onClick={moveOnBackground}>
      <Icon glyph="layer-arrow-down" />
    </Trigger>
  );
};

MoveBackward.displayName = 'MoveBackward';

MoveBackward.propTypes = {
  elementId: PropTypes.string.isRequired,
};

export default MoveBackward;
